<template>
  <div>
    <Head title="Create ItemLocation" />
    <h1 class="mb-8 text-3xl font-bold">
      Master
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/itemlocations">
        ItemLocations
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            v-model="form.name"
            :error="form.errors.name"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name" />
          <select-input
            v-model="form.ref_area_project_id"
            :error="form.errors.ref_area_project_id"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Area Project">
            <option
              :value="null"
              selected
              disabled />
            <option
              v-for="areaproject in areaprojects"
              :key="areaproject.id"
              :value="areaproject.id">
              {{ areaproject.code+" - "+areaproject.location }}
            </option>
          </select-input>
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            class="pb-8 pr-6 w-full lg:w-1/2"
            label="Description" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Create ItemLocation
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    remember: 'form',
    props: {
        areaprojects: Object,
    },
    data () {
        return {
            form: this.$inertia.form({
                name: null,
                ref_area_project_id: null,
                desc: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post('/itemlocations')
        },
    },
}
</script>
